import React from 'react';
import '../../App.css';
import './LegalPages.css';
import Footer from '../Footer';

function TermsOfUse() {
    return (
        <>
            <div className='legal-page'>
                <div className='legal-container'>
                    <h1>Terms of Use</h1>

                    <h2>OVERVIEW</h2>
                    <p>
                        This website is operated by OFFF THE ROAST. Throughout the site, the terms "we",
                        "us" and "our" refer to OFFF THE ROAST. By accessing or using our Services, you
                        agree to be bound by these Terms of Use ("Terms"). These Terms apply to all users
                        of the site, including browsers, students, and customers.
                    </p>

                    <h2>1. USE OF SERVICES</h2>
                    <p>
                        <strong>Personal Use:</strong> These terms permit you to use our Services for
                        personal, non-commercial use only.
                    </p>
                    <p>
                        <strong>Prohibited Conduct:</strong> You must not use our Services in any manner
                        that could disable, overburden, or impair the site. The use of robots, spiders,
                        or other automatic devices to monitor or copy our material is strictly prohibited.
                    </p>
                    <p>
                        <strong>Age Requirement:</strong> By using this site, you represent that you are
                        at least the age of majority in your state of residence.
                    </p>

                    <h2>2. ROASTING SESSIONS & BOOKINGS</h2>
                    <p>
                        <strong>Class Registration:</strong> When you register for a roasting session, you
                        represent that all information provided is accurate and complete. You are solely
                        responsible for all transactions that take place under your account.
                    </p>
                    <p>
                        <strong>Deposit Policy:</strong> A $50 deposit is required to secure your roasting
                        session. This amount is applied toward your final total.
                    </p>
                    <p>
                        <strong>Cancellation & Rescheduling:</strong> To transfer your deposit to a future
                        date, you must reschedule at least 48 hours in advance. Cancellations or no-shows
                        with less than 48 hours' notice will result in the deposit being non-refundable.
                    </p>

                    <h2>3. INTELLECTUAL PROPERTY RIGHTS</h2>
                    <p>
                        All material on our Services, including branding for OFFF THE ROAST, is owned by
                        us and protected by copyright and trademark laws.
                    </p>
                    <p>
                        You must not reproduce, distribute, modify, or create derivative works of any
                        material from our Services without express written consent.
                    </p>

                    <h2>4. LIMITATION OF LIABILITY & DISCLAIMER</h2>
                    <p>
                        <strong>"As Is" Basis:</strong> Your use of our Services and any items obtained
                        through them is at your own risk. Our Services are provided on an "AS IS" and "AS
                        AVAILABLE" basis without warranties of any kind.
                    </p>
                    <p>
                        <strong>Liability Cap:</strong> To the maximum extent permitted by law, OFFF THE
                        ROAST hereby disclaims all warranties, including merchantability and fitness for a
                        particular purpose. We are not liable for any damages arising from your use of the
                        Service.
                    </p>

                    <h2>5. THIRD-PARTY LINKS</h2>
                    <p>
                        You may link to our Services provided you do so in a way that is fair and legal
                        and does not damage our reputation.
                    </p>
                    <p>
                        Our site may contain links to third-party websites (such as Square for booking).
                        We are not responsible for the content or accuracy of third-party materials.
                    </p>

                    <h2>6. GOVERNING LAW</h2>
                    <p>
                        These Terms and any separate agreements for Services shall be governed by and
                        construed in accordance with the laws of the United States.
                    </p>

                    <h2>7. CONTACT INFORMATION</h2>
                    <p>
                        Questions about these Terms of Use should be directed to our official contact
                        channels.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default TermsOfUse;
